import { customer } from "../../../../../types/customer";
import "react-virtualized/styles.css";
import List from "react-virtualized/dist/commonjs/List";
import AutoSizer from "react-virtualized-auto-sizer";
import InfiniteLoader from "react-virtualized/dist/commonjs/InfiniteLoader";
import ListKanbanItem from "./listKanbanItem/listKanbanItem";
import { NavLink } from "react-router-dom";
import {
  CellMeasurerCache,
  ListRowRenderer,
  CellMeasurer,
} from "react-virtualized";
import { useRef } from "react";
import { useResizeObserver } from "usehooks-ts";

const cache = new CellMeasurerCache({
  defaultHeight: 175,
  fixedWidth: true,
});

interface props {
  customers: customer[];
  loadMore: () => void;
  canLoadMore: boolean;
  loading: boolean;
  fetchingMore: boolean;
  totalLength: number;
}

export default function CustomerList({
  customers,
  loadMore,
  canLoadMore,
  totalLength,
  loading,
  fetchingMore,
}: props) {
  const Row: ListRowRenderer = ({ index, style, key, parent }) => (
    <CellMeasurer
      cache={cache}
      columnIndex={0}
      key={key}
      parent={parent}
      rowIndex={index}
    >
      {({ measure, registerChild }) => (
        // @ts-expect-error
        <div style={style} key={index} ref={registerChild || null}>
          <NavLink to={`/customers/detail/${customers[index]?.id}`}>
            <ListKanbanItem customer={customers[index]} measure={measure} />
          </NavLink>
        </div>
      )}
    </CellMeasurer>
  );

  const ref = useRef<HTMLDivElement>(null);

  const onResize = () => {
    cache.clearAll();
  };

  useResizeObserver({
    ref,
    onResize,
  });

  return (
    <div className="h-full flex-1 md:px-10">
      <AutoSizer>
        {({ height, width }) => (
          <InfiniteLoader
            rowCount={totalLength}
            loadMoreRows={async () => {
              canLoadMore && !loading && !fetchingMore && loadMore();
            }}
            isRowLoaded={({ index }) => {
              const bool = !!customers[index];
              return bool;
            }}
          >
            {({ onRowsRendered, registerChild }) => (
              <List
                width={width}
                height={height}
                onRowsRendered={onRowsRendered}
                ref={registerChild}
                className="outline-none"
                rowCount={customers.length}
                rowRenderer={Row}
                deferredMeasurementCache={cache}
                rowHeight={row => {
                  const height = cache.rowHeight(row);
                  return height + 10;
                }}
              />
            )}
          </InfiniteLoader>
        )}
      </AutoSizer>
    </div>
  );
}
